import { useState, useRef } from 'react';
import { FaTimes } from 'react-icons/fa';
import styled from 'styled-components';

const FileUploadContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 10px 10px;
  width: 50%;
`;

const FieldLabel = styled.label`
  color: #82A194;
  font-weight: 400;
`;

const InputContainer = styled.div`
  margin: 1em 0;
  // padding: 1.25em 1.25em;
  display: flex;
  border-radius: 3px;
  border: none;
  background: #C7D0C7;
  font-size: 1em;
`;

const CustomFileInput = styled.label`
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: ${props => props.hover ? "#E8E8E8" : "#D9D9D9"};
  transition: background-color 0.3s;
  display: inline-block;
  padding: 8px 10px;
  cursor: pointer;

  > img {
    max-width: 100%;
    max-height: 100%;
  }

  > input[type="file"] {
    display: none;
  }
`

const FileInfoContainer = styled.div`

  height: 100%;
  width: calc(100% - 67px);
`;

const FileNameContainer = styled.div`
  // height: calc(100% - 8px);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const RemoveButtonHousing = styled.div`
  position: absolute;
  top: 2px;
  right 2px;
  cursor: pointer;
`;

const RemoveButton = styled.button`
  border: none;
  background: none;
  color: #808080;
  border-radius: 100px;
  padding: 3px 5px;
  margin: 0;
  cursor: pointer;
`;

// commented out loading bar, maybe circle back to it later
// const LoadingBar = styled.div`
//   height: 8px;
//   background-color: #67B9DC;
//   width: ${props => props.percentLoaded};
// `;

const ImageUploader = ({setField}) => {
  const [uploadedImage, setUploadedImage] = useState(null);
  const [hovered, setHovered] = useState(false);

  const uploadRef = useRef();

  const imageUploadHandler = (event) => {
    setUploadedImage(event.target.files[0])

    setField('uploadedImage', event.target.files[0])
  }

  const removeImage = () => {
    setUploadedImage(null)
    setField('uploadedImage', null)
  };

  return(
    <FileUploadContainer>
      <FieldLabel>Upload Image</FieldLabel>
      <InputContainer>
        <CustomFileInput
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          hover={hovered}
        >
          <input
            ref={uploadRef}
            type="file"
            accept="image/*"
            onChange={imageUploadHandler}
          />
          <img src="/upload.svg" alt="" />
        </CustomFileInput>
        <FileInfoContainer>
          <FileNameContainer>
            {uploadedImage ?
              <RemoveButtonHousing>
                <RemoveButton
                  onClick={removeImage}
                >
                  <FaTimes/>
                  </RemoveButton>
              </RemoveButtonHousing> : null}
            <p>{uploadedImage ? uploadedImage.name : "No file selected"}</p>
          </FileNameContainer>
          {//<LoadingBarpercentLoaded="66%"/>
          }
        </FileInfoContainer>
      </InputContainer>
    </FileUploadContainer>
  )
}

export default ImageUploader
